/* global translations */
import React, { Component } from 'react';
import get from 'lodash/get';
import ImageSvg from '../image/ImageSvg';

class VerificationBenefits extends Component {
  state = {
    extended: false,
  };

  toggleExtended = (e) => {
    const { extended } = this.state;
    this.setState({ extended: !extended });

    e.currentTarget.blur();
  };

  render() {
    const { extended } = this.state;

    return (
      <div className="verification-benefits mtm">
        <div
          role="button"
          onClick={this.toggleExtended}
          onKeyDown={this.toggleExtended}
          tabIndex="0"
          className="btn btn--c btn--block btn--iconLeft btn--small verification-benefits-title"
        >
          <span>{get(translations, 'txt: Ko man dod verificēts profils', '')}</span>
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg svg={extended ? 'icon-arrowup' : 'icon-arrowdown'} />
              </span>
            </span>
          </span>
        </div>
        {extended && (
          <div className="verification-benefits-content tss ptm plm">
            {get(translations, 'txt: Jo sakārtotāks Tavs profils, jo ātrāk Tevi pamanīs. Profila verificēšana ir vēl viens veids, kā to izdarīt.', '')}
          </div>
        )}
      </div>
    );
  }
}

export default VerificationBenefits;
